export class ConciliacionDataRequest {
  constructor(public readonly games: Array<string>,
              public readonly date: string,
              public readonly page: number,
              public readonly pageSize: number) {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/conciliacion/conciliacion-data-request.ts